import React, { useState } from "react";
import Draggable from "react-draggable";

import Recommendations from "../index";

const LinkRecommendationToCRModal = ({
    onCancel,
    onLink,
    linkLoader = false,
    selectedCount = 0,
    handleLinkSelection,
    defaultFilters = {},
    defaultList = {},
    projectId = ""
}) => {
    const [draggableState, setDraggableState] = useState(false);

    return (
        <div
            className="modal assign-init-modal image-pull-modal config-modal smart-recom"
            style={{ display: "block" }}
            id="modalId"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel=".non-draggable" disabled={draggableState}>
                <div className="modal-dialog assignModal" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">Select Recommendations</div>
                            </h5>
                            <button type="button" className="close non-draggable" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div>
                            <div className="modal-body ">
                                <div className="form-group">
                                    <div className="formInp">
                                        <div className="dashboard-outer">
                                            <div className="outer-detail">
                                                <div className="right-panel-section">
                                                    <div className="dtl-sec">
                                                        <div className="dtl-sec system-building col-md-12 ">
                                                            <div className="tab-dtl region-mng">
                                                                <div className="tab-active recomdn-table bg-grey-table modal-table-scroll">
                                                                    <Recommendations
                                                                        isSmartChartView={true}
                                                                        isCrLinkPicker
                                                                        isDraggable={e => {
                                                                            setDraggableState(e);
                                                                        }}
                                                                        smartChartFilters={defaultFilters}
                                                                        defaultList={defaultList}
                                                                        projectIdForSmartChart={projectId}
                                                                        projectId={projectId}
                                                                        isSurveyView
                                                                        handleSurveyAssign={handleLinkSelection}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 p-0 text-right btnOtr cr-link-footer">
                                        <button type="button" onClick={onCancel} className="btn btn-secondary btnRgion mr-2">
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            disabled={!selectedCount || linkLoader}
                                            onClick={() => onLink()}
                                            className="btn btn-primary btnRgion"
                                        >
                                            Link {linkLoader && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default LinkRecommendationToCRModal;
